import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PopupModal from "../../../Components/ModalComponent/PopupModal";
import InputComponent2 from "../../../Components/InputComponent/InputComponent2";
import {
    convertUtcToBrowserTimeZone,
    dataTableInitialLoader,
    formatingValue,
    limitCharacters,
    preventSpecialChars,
    userValidation,
} from "../../../Functions/Utils";
import { ManageApis } from "../../../AppServices/ManageApi";
import AlertBox from "../../../Components/AlertBox/AlertBox";
import Loader from "../../../Components/LoaderComponent/Loader";
import TableComponent from "../../../Components/TableComponent/TableComponent";
import { MultiSelect } from "react-multi-select-component";
import {
    Button,
    Checkbox,
    Input,
    Message,
    Popconfirm,
    Radio,
    Switch,
} from "@arco-design/web-react";
import DataTable from "../../../Components/DataTable/DataTable";
import InputComponent from "../../../Components/InputComponent/InputComponent";
import Skeleton from "react-loading-skeleton";
import { async } from "q";
import moment from "moment";


let lockoutEnabled = true;
const InputSearch = Input.Search;
// let key = true;
function ClientDetails() {
    const Navigate = useNavigate();
    const { state } = useLocation();
    //console.log("here is the state values", state)
    const { userData } = state || {};
    const [key, setkey] = useState()
    const [keystatus, setkeystatus] = useState()
    const { email, fullName, id} = userData || {};
  

    const [visible, setvisible] = useState({ show: false, type: "" });
    const AlertinitialValue = {
        show: false,
        message: "",
        isfalse: false,
        isSuccess: false,
        isWarning: false,
    };
    const initaialCreatMenu = {
        menuName: "",
        url: "",
        maxCredit: "",
    };
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState('')
    const [currentPage, setcurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [editableRows, setEditableRows] = useState({});
    const [editingRowId, setEditingRowId] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [disableEditCell, setDisableEditCell] = useState(false);
    const [createMenuData, setCreateMenuData] = useState(initaialCreatMenu);
    const [MenuList, setGetMenuList] = useState([]);
    const [formatedMenuList, setFormatedMenuList] = useState([]);
    const [showEdit, setShowEdit] = useState(false);
    const [showAlert, setShowAlert] = useState(AlertinitialValue);
    const [changePasswordData, setChangePasswordData] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
        user_name: fullName,
        email: email,
    });
    const [serviceDataList, setServiceDataList] = useState([]);

    const [isLoading, setisLoading] = useState(false);
    const [tableLoader, setTableLoader] = useState(false);
    const [errors, setErrors] = useState({});
    const [selected, setSelected] = useState([]);

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            // sorter: (a, b) => {                            //not use currently if need sort uncomment it
            //   if (a.name > b.name) {
            //     return 1;
            //   }
            //   if (a.name < b.name) {
            //     return -1;
            //   }
            //   return 0;
            // },
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
        },
        {
            title: "Modified Date",
            dataIndex: "modifiedDate",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
            render: (v, record) => {
                // ""
                return (<div>{convertUtcToBrowserTimeZone(record.modifiedDate)}</div>)
            }
        }, {
            title: "Assign/Unassign",
            dataIndex: "status",
            render: (text, record) => (
                <div className="d-flex align-item-center justify-content-center">
                    <div className="arco_switch">
                        <Popconfirm
                            title={`Are you sure you want to ${record?.status == "Active"
                                ? "unassign"
                                : " assign"
                                } this?`}
                                disabled={!key}
                            onOk={() => handleToggle(record, "isAssignedMenu")}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Switch
                                checked={
                                    record?.status == "Active" ? true : false
                                }
                                disabled={!key}

                            />
                        </Popconfirm>
                    </div>

                </div>
            ),
        },
        // {
        //     title: "Action",
        //     dataIndex: "action",
        //     render: (v, record) => {
        //         //console.log({ record });
        //         return tableLoader ? (
        //             <Skeleton text={{ rows: 1, width: 100 }} />
        //         ) : (
        //             <div className="col-12 ">
        //                 <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
        //                     <button
        //                         className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
        //                         // onClick={() => handleEditClientName(record)}
        //                     >
        //                         Edit
        //                     </button>

        //                     <Popconfirm
        //                         title="Are you Sure ?"
        //                         okText={"OK"}
        //                         cancelText={"Cancel"}
        //                         // onOk={() => handleDeleteService(record.id)}
        //                     >
        //                         <button className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100">
        //                             Delete
        //                         </button>
        //                         {/* <DeleteTwoTone /> */}
        //                     </Popconfirm>
        //                 </div>
        //             </div>
        //         );
        //     },
        //     headerCellStyle: {
        //         backgroundColor: "var(--mastercolor2)",
        //         color: "#fff",
        //     },
        //     width: "300px",
        // },
    ];

    useEffect(() => {
        try {
            // alert(typeof localStorage.getItem('key'))

            
            if (typeof localStorage.getItem('key') == undefined || localStorage.getItem('key') == null || localStorage.getItem('key') == "undefined") {
                // ""
                localStorage.setItem('key', userData?.key)
                localStorage.setItem('keystatus', userData?.status)
            }
        } catch (e) {
            // ""
            //console.log(e)
        }

        if (key == 'undefined' || key == null || key == undefined) {
            // ""
            try {
                if (localStorage.getItem('key') == "undefined" || localStorage.getItem('key') == "null") {
                    setkey(null)
                    setkeystatus(null)
                }
                else {
                    const oldKey = localStorage.getItem('key')
                    const oldKeyStatus = localStorage.getItem('keystatus')
                    setkey(oldKey)
                    setkeystatus(oldKeyStatus)

                }
            }
            catch (e) {
                //console.log(e)
                // Navigate(-1)
            }
        }

    }, [])
    

    const getServiceListDetails = async () => {
        try {
            setisLoading(true);
            setServiceDataList(dataTableInitialLoader(columns));
            let response = await ManageApis("get", global.clientServices + `?clientId=${id}`);
            //console.log(response);

            if (response.message === "Success") {
                setisLoading(false);
                setData(response?.response_data);
                setServiceDataList((pre) => response?.response_data);
            } else {
                setisLoading(false);
                //console.log(response);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: response?.response_data?.message,
                    isfalse: true,
                }));
            }
        } catch (error) {
            setisLoading(false);
            //console.log(error);
        }
    };

    let chnagepasswordForm = [
        {
            col: "col-6",
            type: "text",
            name: "user_name",
            label: "User Name",
            isDisabled: true,
            error: "",
            value: fullName,
        },
        {
            col: "col-6",
            type: "email",
            name: "email",
            label: "Email",
            isDisabled: true,
            error: "",
            value: email,
        },
        {
            type: "password",
            name: "current_password",
            label: "Current Password",
            isDisabled: false,
            error: "",
            value: changePasswordData.current_password,
        },
        {
            type: "password",
            name: "new_password",
            label: "New Password",
            isDisabled: false,
            error: "",
            value: changePasswordData.new_password,
        },
        {
            type: "password",
            name: "confirm_password",
            label: "Confirm Password",
            isDisabled: false,
            error: "",
            value: changePasswordData.confirm_password,
        },
    ];
    const [PasswordData, setPasswordData] = useState(chnagepasswordForm);

    useEffect(() => {
        GetMenuList();
         getServiceListDetails()
        // //console.log(id);
    }, []);

    const handleCheckAllRow = (isChecked) => {
        if (isChecked) {
            setSelectedRows([
                ...selectedRows,
                ...formatedMenuList.map((itm) => itm?.id),
            ]);
        } else {
            setDisableEditCell(false);
            setSelectedRows([]);
            setEditableRows({});
        }
    };

    const handleToggle = async (param) => {
        
    
            try {
                let reqstBody = {
                    clientId: id,
                    serviceId: param.id,
                    status: param?.status=="Active"?"Inactive":"Active",
                }
                
                let result = await ManageApis(
                    "post",
                    global.ServiceToClient,
                    reqstBody
                );
                if (result.message === "Success") {
                    setisLoading(false);

                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: "Successfully Updated...!",
                        isSuccess: true,
                        isfalse: false,
                    }));
                } else {
                    setisLoading(false);
                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: "Somthing went wrong...!",
                        isSuccess: false,
                        isfalse: true,
                    }));
                }
            } catch (err) {
                // //console.log(err);
            }
       
      
    };
    const handleChangePassword = async () => {
        //handle change password acount  button click

        const validate = () => {
            let isValid = true;
            // //console.log(userData);
            let array = Object.keys(changePasswordData);
            let result = userValidation(changePasswordData, array);

            result.forEach((item) => {
                if (item !== "email" && item !== "fullName") {
                    handleError(`Please fill the ${item.replace("_", " ")}`, item);
                    isValid = false;
                }
            });

            // //console.log(result);

            Object.keys(errors).forEach((key) => {
                if (errors[key]) {
                    isValid = false;
                    // //console.log(errors[key]);
                }
            });

            return isValid;
        };
        try {
            if (validate()) {
                setisLoading(true);
                setvisible((pre) => ({
                    show: false,
                    type: "",
                }));
                const reqstBody = {
                    id: userData?.id,
                    emailId: userData?.email,
                    currentPassword: changePasswordData.current_password,
                    newPassword: changePasswordData.new_password,
                    confirmNewPassword: changePasswordData.confirm_password,
                };
                let result = await ManageApis("post", global.changePassword, reqstBody);
                if (result.message === "Success") {
                    // //console.log(result);
                    if (result?.response_data == "Password changed successfully.") {
                        setChangePasswordData((pre) => ({

                            confirm_password: "",
                            current_password: "",
                            new_password: "",
                        }));
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: result.response_data,
                            isSuccess: true,
                        }));
                        setisLoading(false);
                    }
                    else {
                        setChangePasswordData((pre) => ({

                            confirm_password: "",
                            current_password: "",
                            new_password: "",
                        }));
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: result.response_data,
                            isSuccess: false,
                            isWarning: true,
                        }));
                        setisLoading(false);
                    }
                    // alert("Password changed successfully.");
                } else {
                    setChangePasswordData((pre) => ({
                        ...pre,
                        confirm_password: "",
                        current_password: "",
                        new_password: "",
                    }));
                    setisLoading(false);
                    // //console.log(result);
                    setvisible((pre) => ({
                        show: false,
                        type: "",
                    }));
                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: result.response_data,
                        isSuccess: false,
                        isfalse: true,
                    }));
                }
            }
        } catch (err) {
            // //console.log(err);
        }
    };

    const handleActive_Detactivate = async () => {
        try {
            setisLoading(true)
            const param = `ClientServiceKeyId=${key}`
            const changedkeyStatus = keystatus === "Active" ? 'Deactivated' : 'Activated';
            let url = keystatus === "Active" ? global.deActivateKey + param : global.activateKey + param
            let response = await ManageApis("post", url,)
            if (response.message === "Success") {
                //console.log(response)
                setisLoading(false)
                // ""
                const newKeyStatus = keystatus == "Active" ? "Inactive" : "Active"
                setkeystatus(newKeyStatus)
                localStorage.setItem("keystatus", newKeyStatus)

                // setvisible(initialVisibleValue)
                Message.success(`Key ${changedkeyStatus} Succcessfully`)
                // getServiceKeyDataList()

                // setTimeout(() => { window.location.href = '/ServicesKey' }, 1000)
            } else {
                setisLoading(false)
                //console.log(response)
            }

        } catch (error) {
            setisLoading(false)
            //console.log(error)

        }
    }
    // handle deactivate account
    const handleActivateAccount = async () => {
        //handle deactivate acount  button click
        try {
            setisLoading(true);
            const reqstBody = {
                id: userData?.id,

            };
            let result = await ManageApis("post", global.activate, reqstBody);
            if (result.message === "Success") {
                // //console.log(result);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: "Activated successfully",
                    isSuccess: true,
                }));
                // setTimeout(() => {
                //   Navigate(-1)
                // }, 1500);
                setisLoading(false);
            } else {
                // //console.log(result);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: result.response_data
                        ? result.response_data
                        : "Something went wrong...!",
                    isSuccess: false,
                    isfalse: true,
                }));
                setisLoading(false);
            }
        } catch (err) {
            // //console.log(err);
        }
    };
    const handleDeactivateAccount = async () => {
        //handle deactivate acount  button click
        try {
            setisLoading(true);
            const reqstBody = {
                id: userData?.id,

            };
            let result = lockoutEnabled ? await ManageApis("post", global.activate + `?id=${userData?.id}`) : await ManageApis("post", global.Deactivate + `?id=${userData?.id}`);
            if (result.message === "Success") {
                // //console.log(result);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: !lockoutEnabled ? 'Activated Successfully' : "Deactivated Successfully",
                    isSuccess: true,
                }));
                // setTimeout(() => {
                //   Navigate(-1)
                // }, 1500);
                lockoutEnabled = lockoutEnabled ? false : true;
                localStorage.setItem('storedLockenabled', lockoutEnabled)
                setisLoading(false);
            } else {
                // //console.log(result);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: result.response_data
                        ? result.response_data
                        : "Something went wrong...!",
                    isSuccess: false,
                    isfalse: true,
                }));
                setisLoading(false);
            }
        } catch (err) {
            // //console.log(err);
        }
    };

    const handleError = (error, input) => {
        setErrors((prevState) => ({ ...prevState, [input]: error }));
    };

    const handleChange = (e, type, regex, max) => {
        const { name, value } = e.target;
        // //console.log(name, value, type);

        if (type == "changepassword") {
            // ""
            switch (name) {
                case "current_password":
                    setChangePasswordData((prevState) => ({
                        ...prevState,
                        [name]: value.slice(0, 12).replace(" ", "").trim(),
                    })); //maxlength 12
                    if (!value) {
                        handleError("Please enter current password", name);
                    }
                    if (
                        changePasswordData.new_password &&
                        value === changePasswordData.new_password
                    ) {
                        handleError("current password can't be same as new password", name);
                    } else {
                        handleError(null, name);
                        handleError(null, "new_password");
                    }


                    break;

                case "new_password":
                    setChangePasswordData((prevState) => ({
                        ...prevState,
                        new_password: value.slice(0, 12).replace(" ", "").trim(),
                    })); //maxlength 12
                    if (
                        changePasswordData.confirm_password &&
                        value !== changePasswordData.confirm_password
                    ) {
                        handleError("Passwords do not match", name);
                    } else if (
                        changePasswordData.current_password &&
                        value === changePasswordData.current_password
                    ) {
                        handleError("new password can't be same as current password", name);
                    }

                    else {
                        handleError(null, name);
                        handleError(null, "confirm_password");
                        handleError(null, "current_password");
                    }

                    break;
                case "confirm_password":
                    setChangePasswordData((prevState) => ({
                        ...prevState,
                        [name]: value.slice(0, 12).replace(" ", "").trim(),
                    })); //maxlength 12
                    if (
                        changePasswordData.new_password &&
                        changePasswordData.new_password !== value
                    ) {
                        handleError("Passwords do not match", name);
                    } else {
                        handleError(null, name);
                        handleError(null, "new_password");
                    }

                    break;

                default:
                    break;
            }
        } else {
            switch (name) {
                case name:
                    setCreateMenuData((prevState) => ({
                        ...prevState,
                        [name]: regex ? formatingValue(value, max, regex) : value,
                    }));
                    handleError(null, [name]);
                default:
                    break;
            }
        }
    };

    // handle delete menu api not in use
    const handleDeleteMenu = async (params) => {
        try {
            setisLoading(true);

            let result = await ManageApis(
                "post",
                `${global.DeleteMenu}?id=${params.id}`
            );
            if (result.message == "Success") {
                setisLoading(false);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: "Menu Deleted SuccessFully",
                    isSuccess: true,
                }));
                setFormatedMenuList((prev) => result?.response_data);
            } else {
                setisLoading(false);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: "Something Went wrong",
                    isfalse: true,
                }));
                // //console.log(result);
            }
        } catch (err) {
            // //console.log(err);
        }
    };


    //get menulist
    const GetMenuList = async () => {
        // ""
        try {
            setisLoading(true);
            const param = `?clientId=${id}`;
            let result = await ManageApis("get", global.getMenuList + param);
            if (result.message == "Success") {
                // //console.log(result?.response_data)

                setGetMenuList(result?.response_data);
                setFormatedMenuList(
                    result?.response_data.map((item) => {
                        // Check if isAssignedMenu is 1, set it to true, otherwise set it to false
                        item.isAssignedMenu = item.isAssignedMenu === 1 ? true : false;
                        return item;
                    })
                );

                // //console.log(result?.response_data);

                setisLoading(false);
            } else {
                // //console.log(result);
                setisLoading(false);
            }
        } catch (err) {
            // //console.log(err);
        }
    };


    // handle Add Menu
    const handleAddMenu = async () => {
        const validate = () => {
            let isValid = true;
            // //console.log(userData);
            let array = Object.keys(createMenuData);
            let result = userValidation(createMenuData, array);

            result.forEach((item) => {
                handleError(`Please Enter the ${item.replace("_", " ")}`, item);
                isValid = false;
            });

            // //console.log(result);

            Object.keys(errors).forEach((key) => {
                if (errors[key]) {
                    isValid = false;
                    // //console.log(errors[key]);
                }
            });

            return isValid;
        };
        try {
            if (validate()) {
                setisLoading(true);

                setvisible((pre) => ({
                    show: false,
                    type: "",
                }));
                const reqstBody = {
                    ...createMenuData,
                    maxCredit: parseInt(createMenuData.maxCredit),
                };
                let result = await ManageApis("post", global.CreateMenu, reqstBody);
                if (result.message == "Success") {
                    // //console.log(result);
                    setCreateMenuData(initaialCreatMenu);
                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: "Add Menu Successfully",
                        isSuccess: true,
                    }));
                    setGetMenuList(result?.response_data);

                    setFormatedMenuList(
                        result?.response_data.map((item) => {
                            // Check if isAssignedMenu is 1, set it to true, otherwise set it to false
                            item.isAssignedMenu = item.isAssignedMenu === 1 ? true : false;
                            return item;
                        })
                    );

                    setisLoading(false);
                } else {
                    setCreateMenuData(initaialCreatMenu);
                    setisLoading(false);
                    // //console.log(result);
                    setvisible((pre) => ({
                        show: false,
                        type: "",
                    }));
                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: "Something went wrong...!",
                        isSuccess: false,
                        isfalse: true,
                    }));
                }
            }
        } catch (err) {
            // //console.log(err);
        }
    };

    const handleAddMenuToUser = async () => {
        try {
            setisLoading(true);
            setvisible((pre) => ({
                show: false,
                type: "",
            }));
            const reqstBody = {
                userId: userData?.id,
                menuList: selected.map((itm) => itm.value),
            };

            let result = await ManageApis("post", global.createMenuToUser, reqstBody);
            if (result.message == "Success") {
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: "Menu added to User Successfully",
                    isSuccess: true,
                    isfalse: false,
                }));

                setSelected([]);
                setisLoading(false);
            } else {
                setvisible((pre) => ({
                    show: false,
                    type: "",
                }));
                // //console.log(result);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: "Something went wrong",
                    isSuccess: true,
                    isfalse: false,
                }));
                setSelected([]);
                setisLoading(false);
            }
        } catch (err) {
            // //console.log(err);
        }
    };

    // render popup modal children with type props
    const renderPopupChildren = () => {
        switch (visible.type) {
            case "changepassword":
                return (
                    <>
                        {PasswordData.map((itm) => (
                            <div
                                className={`${itm.hasOwnProperty("col") ? itm.col : "col-12"}`}
                            >
                                <InputComponent2
                                    label={itm.label}
                                    name={itm.name}
                                    type={itm.type}
                                    value={changePasswordData[itm.name]}
                                    error={errors[itm.name]}
                                    disabled={itm.isDisabled}
                                    onchange={(e) => handleChange(e, visible.type)}
                                />
                            </div>
                        ))}
                        <div className=" d-flex justify-content-end">
                            <button
                                className="btn btn-master px-3 font_14"
                                onClick={handleChangePassword}
                            >
                                Submit
                            </button>
                        </div>
                    </>
                );

                break;

        }
    };

    const handleEdit = (id) => {
        if (!disableEditCell) {
            setEditingRowId(id);
            setEditableRows((prevState) => ({
                [id]: !prevState[id], // Toggle edit mode for the clicked row
            }));
            setSelectedRows([id]);
        }
    };

    const handleSave = async (param) => {
        //console.log(formatedMenuList.filter((itm) => itm.id == param));

        // "";
        try {
            setisLoading(true);
            let reqstBody = {
                UserId: id,
                editItems: formatedMenuList
                    .filter((itm) => selectedRows.includes(itm.id))
                    .map(({ id, maxCredit, isAssignedMenu }) => ({
                        id: param,
                        isAssigned: Boolean(isAssignedMenu),
                        MaxCredit: maxCredit ? Number(maxCredit) : 0,
                    })),
            };
            // ""

            // let reqstBody = formatedMenuList.filter((itm) => itm.id == id);
            let result = await ManageApis("post", global.EditMenuItems, reqstBody);
            if (result.message === "Success") {
                setEditableRows({});
                setEditingRowId(null);

                setSelectedRows(selectedRows.filter((rowId) => rowId !== param));
                setisLoading(false);

                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: "Successfully Updated...!",
                    isSuccess: true,
                    isfalse: false,
                }));
            } else {
                setisLoading(false);
                setShowAlert((pre) => ({
                    ...pre,
                    show: true,
                    message: "Somthing went wrong...!",
                    isSuccess: false,
                    isfalse: true,
                }));
            }
        } catch (err) {
            // //console.log(err);
        }
        // You can implement the logic to save the changes here
    };

    const handleCancel = (id) => {
        // ""
        const updatedEditableRows = { ...editableRows };
        delete updatedEditableRows[id];
        setEditableRows(updatedEditableRows);
        setEditingRowId(null);
        setFormatedMenuList(
            MenuList.map((item) => {
                // Check if isAssignedMenu is 1, set it to true, otherwise set it to false
                item.isAssignedMenu = item.isAssignedMenu === 1 ? true : false;
                return item;
            })
        );
        setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    };

    const handleInputChange = (id, field, value) => {
        // //console.log(id, field, value);
        // "";
        const updatedData = formatedMenuList.map((item) =>
            item.id === id
                ? {
                    ...item,
                    [field]:
                        field === "maxCredit"
                            ? preventSpecialChars(value, 5, /[^0-9\s]/g)
                            : value,
                }
                : item
        );
        // //console.log(updatedData);
        setFormatedMenuList(updatedData);
    };

    const handleCheckboxChange = (id) => {
        if (selectedRows.includes(id)) {
            // Uncheck the row
            setSelectedRows(selectedRows.filter((rowId) => rowId !== id));

            // Remove the row from editableRows state if it's unchecked
            const updatedEditableRows = { ...editableRows };
            delete updatedEditableRows[id];
            setEditableRows(updatedEditableRows);
            // //console.log(updatedEditableRows);
        } else {
            // Check the row
            setSelectedRows([...selectedRows, id]);
        }
    };
    const handleMakeSelectedRowsEditable = async (iseditable) => {
        if (selectedRows.length > 0) {
            setDisableEditCell(iseditable);
            try {
                if (iseditable) {
                    setEditingRowId(null);
                    const updatedEditableRows = { ...editableRows };
                    selectedRows.forEach((id) => {
                        updatedEditableRows[id] = true;
                    });
                    setEditableRows(updatedEditableRows);
                    // //console.log(updatedEditableRows);
                } else {
                    try {
                        // // //console.log(
                        //   formatedMenuList
                        //     .filter((itm) => selectedRows.includes(itm.id))
                        //     .map(({ id, maxCredit, isAssignedMenu }) => ({
                        //       id,
                        //       isAssigned: Boolean(isAssignedMenu),
                        //       MaxCredit: maxCredit,
                        //     }))
                        // );

                        setisLoading(true);

                        // // //console.log(
                        //   formatedMenuList.filter((itm) => selectedRows.includes(itm.id))
                        // );
                        let reqstBody = {
                            UserId: id,
                            editItems: formatedMenuList
                                .filter((itm) => selectedRows.includes(itm.id))
                                .map(({ id, maxCredit, isAssignedMenu }) => ({
                                    id,
                                    isAssigned: isAssignedMenu,
                                    MaxCredit: maxCredit ? Number(maxCredit) : 0,
                                })),
                        };
                        // //console.log(reqstBody);

                        let response = await ManageApis(
                            "post",
                            global.EditMenuItems,
                            reqstBody
                        );
                        if (response.message === "Success") {
                            setisLoading(false);
                            setShowAlert((pre) => ({
                                ...pre,
                                show: true,
                                message: "Updated Successfully...!",
                                isSuccess: true,
                                isfalse: false,
                            }));

                        } else {
                            setisLoading(false);
                            setShowAlert((pre) => ({
                                ...pre,
                                show: true,
                                message: "Somthing went wrong...!",
                                isSuccess: false,
                                isfalse: true,
                            }));
                        }
                    } catch (err) { }
                    setSelectedRows([]);
                    setEditableRows({});
                    setisLoading(false);
                }
            } catch (err) {
                // //console.log(err);
            }
        } else {
            setShowAlert((pre) => ({
                ...pre,
                show: true,
                message: "Please select row to Update..!",
                isSuccess: false,
                isfalse: true,
            }));
        }
    };

    const handleOnclose = () => {
        if (showAlert.isSuccess) {
            GetMenuList();
            getServiceListDetails()
            setShowAlert(AlertinitialValue);
        } else {
            setShowAlert(AlertinitialValue);
        }
    };



    const handlesearch = (value) => {
        setSearchText(limitCharacters(value, 20))
        try {
            if (limitCharacters(value, 20)) {
                setServiceDataList(() => (
                    data.filter((itm) => (itm?.name?.toLowerCase().includes(value?.toLowerCase())))
                ))
            } else {
                setServiceDataList(data)
            }

        } catch (error) {
            // console.error("An error occurred:", error.message);
        }
    }
    function onChangeTable(pagination) {
        // ""
        //console.log(pagination);
        const { current, pageSize } = pagination;
        setTableLoader(true);
        setServiceDataList(dataTableInitialLoader(columns));
        // setServiceDataList({});
        setTimeout(() => {
            setServiceDataList(
                data.slice((current - 1) * pageSize, current * pageSize)
            );
            setPageSize(pageSize)
            setcurrentPage(current);
            setTableLoader(false);
        }, 2000);
    }
    // const onChangeTable = (pagination) => {
    //     // "";
    //     // //console.log(pagination);

    //     const { current, pageSize } = pagination;
    //     // //console.log({ pageSize });

    //     if (!disableEditCell) {

    //         setTableLoader(true);

    //         setFormatedMenuList(dataTableInitialLoader(columns));
    //         setTimeout(() => {
    //             setFormatedMenuList(
    //                 MenuList.slice((current - 1) * pageSize, current * pageSize)
    //             );
    //             setPageSize(pageSize);
    //             setcurrentPage(current);
    //             setTableLoader(false);
    //         }, 2000);
    //     } else {
    //         setShowAlert((pre) => ({
    //             ...pre,
    //             show: true,
    //             message: "Please save/cancel the changes you've made in User Data",
    //             isSuccess: false,
    //             isfalse: true,
    //         }));
    //     }

    // };


    const handleUpdate_Generate = async () => {
        const param = `ClientId=${userData.id}`
        let response = await ManageApis("get", global.generateKey, param)
        if (response?.message === "Success") {
            //console.log(response)
            Message.success("Key Generated Successfully")
            // ""
            localStorage.setItem("key", response?.response_data)
            localStorage.setItem("keystatus", "Active")
            setkey(response?.response_data)
            setkeystatus("Active")
        } else {
            Message.error('Key Generation Failed')
            //console.log(response)
        }
    }

    return (
        <div className="p-2">
            {isLoading && <Loader />}
            <div class="d-flex justify-content-between">
                <div
                    class="mb-2 round_sm d-flex bg_master rounded-circle cursor-pointer align-items-center justify-content-center px_hover_1"
                    onClick={() => Navigate(-1)}
                >
                    <i className="fas fa-chevron-left text-white me-1"></i>
                </div>

            </div>

            <div className="admin_Section overflow-auto scrollbar1">
                <div className="bd_master2_d1 border rounded">
                    <div className="bg_test rounded py-1">
                        <h3 className="text_master2 mb-0 text-uppercase px-3 py-2 font_15 fw_600">
                            Account Information
                        </h3>
                    </div>
                    <div className="px-3 pt-3 pb-3">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="row mb-1">
                                    <div className="col-4 font_14 text_m1 fw_500">Name</div>
                                    <div className="col-8 pt-sm-0 mb-sm-0">
                                        <div className="d-flex">
                                            <span className="pe-1 ">:</span>
                                            <span className="text-black font_14 word_break">
                                                {userData?.name}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-4 font_14 text_m1 fw_500">Created Date</div>
                                    <div className="col-8 pt-sm-0 mb-sm-0">
                                        <div className="d-flex">
                                            <span className="pe-1 ">:</span>
                                            <span className="text-black font_14 word_break">
                                                {moment(userData?.createdDate).format("YYYY-MM-DD")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 text_m1 font_14 fw_500">Is Active</div>
                                    <div className="col-8  pt-sm-0 mb-sm-0">
                                        <div className="d-flex">
                                            <span className="pe-1 ">:</span>
                                            <span className="text-black font_14 word_break">
                                                {keystatus == "Active" ? 'Yes' : 'No'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="d-flex flex-column flex-md-row g-1 justify-content-end mt-3 mt-md-0">
                                    {key && <button
                                        className="btn btn-master flex-fill flex-md-grow-0 font_14 px-4"
                                        onClick={() => {
                                            //set key
                                            setShowAlert((pre) => ({
                                                ...pre,
                                                show: true,
                                                message: key,
                                                isSuccess: false,
                                                isfalse: false,
                                            }));
                                        }
                                        }
                                    >
                                        View Key
                                    </button>}

                                    {key ?
                                        <Popconfirm
                                            title={`Are you sure you want to update the key`}
                                            onOk={handleUpdate_Generate}
                                            okText="Yes"
                                            cancelText="No"
                                        >

                                            <button
                                                className="btn btn-master flex-fill flex-md-grow-0 font_14 ms-md-2 mt-2 mt-md-0 px-4"
                                            // onClick={handleUpdate_Generate}
                                            >
                                                Update Key
                                            </button>
                                        </Popconfirm>
                                        :
                                        <button
                                            className="btn btn-master flex-fill flex-md-grow-0 font_14 ms-md-2 mt-2 mt-md-0 px-4"
                                            onClick={handleUpdate_Generate}
                                        >
                                            Generate Key
                                        </button>

                                    }
                                    {key && 
                                    <>
                                     {keystatus == "Active" ? 
                                        <Popconfirm
                                        title={`Are you sure you want to deactivate key?`}
                                            disabled={!key}
                                        onOk={handleActive_Detactivate}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                         <button
                                            className="btn btn-master flex-fill flex-md-grow-0 font_14 ms-md-2 mt-2 mt-md-0 px-4"
                                            
                                        >
                                            Deactivate Key
                                        </button>
                                    </Popconfirm>
                                        : 
                                        <button
                                        className="btn btn-master flex-fill flex-md-grow-0 font_14 ms-md-2 mt-2 mt-md-0 px-4"
                                        onClick={handleActive_Detactivate}
                                    >
                                        Activate Key
                                    </button>
                                        }
                                    </>
                                    

                                   
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bd_master2_d1 border rounded mt-3">
                    <div className="bg_test rounded d-flex justify-content-between align-items-center p-3">
                        <h3 className="text_master2 mb-0 text-uppercase  font_15 fw_600">
                            Services
                        </h3>

                        <div className="  flex-column flex-md-row g-1 d-flex align-items-center justify-content-between ">
                            <div className=" align-items-center arco_inputsearch d-flex">
                                {/* <input className={`form-control`} onChange={handlesearch}/>
                <i className="far fa-eye  icn p-2 text_gray"></i>
              <i class="fa-solid fa-check"></i> */}
                                <div className="me-2">
                                    <button
                                        className="btn btn-master flex-fill flex-md-grow-0 font_14 px-4"
                                        onClick={() =>
                                            getServiceListDetails()
                                        }
                                    >
                                        Refresh
                                    </button>
                                </div>

                                <InputSearch value={searchText} onChange={handlesearch} allowClear placeholder='Enter service name ' />
                            </div>
                            {/* {!disableEditCell ? (
                                <button
                                    class="btn btn-master font_13 ms-md-2 mt-2 mt-md-0"
                                    onClick={() => handleMakeSelectedRowsEditable(true)}
                                >
                                    Edit User Data
                                </button>
                            ) : (
                                <div className="d-flex justify-content-center">
                                    <button
                                        className="btn btn-master font_13  ms-md-2 mt-2 mt-md-0"
                                        onClick={() => handleMakeSelectedRowsEditable(false)}
                                    >
                                        Save
                                    </button>
                                    <button
                                        className="btn btn-danger font_13  ms-md-2 mt-2 mt-md-0"
                                        onClick={() => {
                                            // ""
                                            // //console.log(MenuList)

                                            setDisableEditCell(false);
                                            setSelectedRows([]);
                                            setEditableRows({});
                                            setFormatedMenuList(
                                                MenuList)


                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            )} */}
                            <button
                                className="btn  d-none btn-master font_13 ms-md-2 mt-2 mt-md-0"
                                onClick={() =>
                                    setvisible((pre) => ({ show: true, type: "createMenu" }))
                                }
                            >
                                Add Menu+
                            </button>
                        </div>
                    </div>
                    <div className="table_type02 table-responsive userview_table p-3 custom_scroll1">
                        <div className="d-none">
                            <table className="table table-bordered pb-2 mb-0 bg-white rounded-2 border font_13 valign_middle">
                                <thead className="bg_master text-white">
                                    <tr>
                                        {[
                                            "",
                                            "Menu",
                                            "Maximum Test Attempt",
                                            "Assign/NotAssign",
                                            "Remaining Count",
                                            "Used Count",
                                            "",
                                        ].map((item, index) => (
                                            <th key={index} className="fw_500">
                                                {item}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="border-top-0">
                                    {formatedMenuList.map((item) => (
                                        console.log(item),
                                        <tr key={item.id}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    disabled={disableEditCell}
                                                    checked={selectedRows.includes(item.id)}
                                                    onChange={() => handleCheckboxChange(item.id)}
                                                />
                                            </td>
                                            {[
                                                "name",
                                                "maxCredit",
                                                "isAssignedMenu",
                                                "remainingCount",
                                                "usedCount",
                                            ].map((dataKey, columnIndex) => (
                                                <td key={columnIndex}>
                                                    {dataKey === "isAssignedMenu" ? (
                                                        <div className="data w-100">
                                                            <Radio.Group
                                                                onChange={(e) =>
                                                                    handleInputChange(item.id, dataKey, e)
                                                                }
                                                                value={
                                                                    formatedMenuList.find(
                                                                        (itm) => itm.id === item.id
                                                                    )?.[dataKey]
                                                                }
                                                                name="button-radio-group"
                                                                disabled={!editableRows[item.id]}
                                                            >
                                                                {[true, false].map((item) => {
                                                                    return (
                                                                        <Radio key={item} value={item}>
                                                                            {({ checked }) => {
                                                                                return (
                                                                                    <Button
                                                                                        tabIndex={-1}
                                                                                        key={item}
                                                                                        shape="round"
                                                                                        type={
                                                                                            checked ? "primary" : "default"
                                                                                        }
                                                                                    >
                                                                                        {item == true
                                                                                            ? "Assigned"
                                                                                            : "Not Assigned"}
                                                                                    </Button>
                                                                                );
                                                                            }}
                                                                        </Radio>
                                                                    );
                                                                })}
                                                            </Radio.Group>
                                                        </div>
                                                    ) : dataKey === "maxCredit" ? (
                                                        editableRows[item.id] ? (
                                                            <input
                                                                type={`${dataKey === "maxCredit" ? "tel" : "text"
                                                                    }`}
                                                                className="form-control"
                                                                value={
                                                                    formatedMenuList.filter(
                                                                        (itm) => itm.id == item.id
                                                                    )[0][dataKey]
                                                                }
                                                                onChange={(e) =>
                                                                    handleInputChange(
                                                                        item.id,
                                                                        dataKey,
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        ) : (
                                                            item[dataKey]
                                                        )
                                                    ) : (
                                                        item[dataKey]
                                                    )}
                                                </td>
                                            ))}
                                            <td style={{ width: "150px" }}>
                                                {editingRowId === item.id && !disableEditCell ? (
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            className="btn btn-master btn-sm"
                                                            onClick={() => handleSave(item.id)}
                                                        >
                                                            Save
                                                        </button>
                                                        <button
                                                            className="btn btn-danger btn-sm ms-2"
                                                            onClick={() => handleCancel(item.id)}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex justify-content-center">
                                                        <i
                                                            className="fas fa-pen font_14 cursor-pointer"
                                                            onClick={() => handleEdit(item.id)}
                                                        ></i>
                                                        {/* not in use  */}
                                                        {
                                                            <i
                                                                className="fas fa-trash-alt text-danger font_14 cursor-pointer ms-2"
                                                                onClick={() => handleDeleteMenu(item)}
                                                            ></i>
                                                        }
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* <DataTable
                            loading={tableLoader}
                            columnData={columns}
                            rowData={formatedMenuList}
                            current={currentPage}
                            pageSize={pageSize}
                            total={MenuList.length}
                            onChangeTable={onChangeTable}
                        /> */}
                        <DataTable
                            columnData={columns}
                            rowData={serviceDataList}
                            loading={tableLoader}
                            pageSize={pageSize}
                            current={currentPage}
                            total={data.length}
                            onChangeTable={onChangeTable}
                        />
                    </div>
                </div>
            </div>

            <PopupModal
                title=""
                size="md"
                visible={visible.show}
                handleClose={() => { setvisible((prv) => ({ show: false, type: "" })); setErrors({}) }}
            >
                <div className="row">{renderPopupChildren()}</div>
            </PopupModal>

            <AlertBox
                show={showAlert.show}
                message={showAlert.message}
                enableFailIcon={showAlert.isfalse}
                enableSuccessIcon={showAlert.isSuccess}
                enableWarningIcon={showAlert.isWarning}
                handlecancel={handleOnclose}
            />
        </div>
    );
}

export default ClientDetails;
